import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

const MenuIcon = styled(Box)(({ theme, open }) => ({
  width: '3.25rem',
  height: '1rem',
  position: 'relative',
  gap: '0.625rem',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'center',
  transition: 'transform 0.3s ease-in-out',
  '& span': {
    position: 'absolute',
    height: '0.1875rem',
    backgroundColor: theme.palette.text.primary,
    borderRadius: '2px',
    transition: 'all 0.4s ease-in-out',
  },
  '& span:first-of-type': {
    width: open ? '70%' : '100%',
    top: open ? '50%' : '0',
    transform: open ? 'rotate(45deg)' : 'none',
  },
  '& span:last-of-type': {
    width: open ? '70%' : '60%',
    bottom: open ? '30%' : '0',
    transform: open ? 'rotate(-45deg)' : 'none',
  },
}));

function AnimatedMenuButton({ open }) {
  return (
    <MenuIcon open={open}>
      <span />
      <span />
    </MenuIcon>
  );
}

AnimatedMenuButton.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default AnimatedMenuButton;
